
import styled from 'styled-components';
import GetStartedRequestDemoSide from '../components/generic/GetStartedRequestDemoSide';
import DataAnalyticsIntro from '../components/DataAnalytics/DataAnalyticsIntro';
import DataAnalyticsInfo from '../components/DataAnalytics/DataAnalyticsInfo';
import GetStartedQuickly from '../components/DataAnalytics/GetStartedQuickly';
import DataDriven from '../components/DataAnalytics/DataDriven';
import TrackingComponent from '../components/Tracking/TrackingComponent';
import { lightThemeColors } from '../assets/style/colors';
import { ReactComponent as GridAssetIcon } from "../assets/decorations/blueBannerGrid.svg";
import { Helmet } from 'react-helmet-async';


const DataAnalyticsPage = () => {


    return (
        <>
            < Helmet>
                <title>Grovs Data & Analytics | Clear, Reliable Campaign Insights</title>
                <meta
                    name="description"
                    content="Empower your Data & Analytics team with precise tracking of installs, reactivations, and deep link interactions. Grovs delivers clear user journey insights and streamlined reporting—without complex setups."
                />
                <meta
                    name="keywords"
                    content="data analytics, campaign tracking, user acquisition data, reactivation analytics, deep linking analytics, attribution, marketing ROI, data export, Grovs analytics"
                />
                <meta name="robots" content="index, follow" />

                {/* Open Graph / Facebook */}
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Grovs Data & Analytics | Precise, Actionable Insights" />
                <meta
                    property="og:description"
                    content="Simplify attribution and unlock clear visibility into campaigns and user journeys with Grovs. Accurate, real-time data made easy for Data & Analytics teams."
                />
                <meta property="og:url" content="https://www.grovs.io/data-analytics" />
                <meta
                    property="og:image"
                    content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/social-media-placeholder.jpg"
                />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Grovs Data & Analytics | Clear Insights for Smarter Decisions" />
                <meta
                    name="twitter:description"
                    content="Get precise campaign and user acquisition data, track installs, reactivations, and deep link performance with Grovs—all with easy exports and unified dashboards."
                />
                <meta
                    name="twitter:image"
                    content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/social-media-placeholder.jpg"
                />
            </Helmet>
            <Container>
                <DataAnalyticsIntro />
                <DataAnalyticsInfo />
                <GetStartedQuickly />
                <DataDriven />
                <GetStartedRequestDemoSide
                    bgColor={lightThemeColors.measureBg}
                    gradientColor={"rgba(91, 104, 223, 1)"}
                    titleStyle={{ color: lightThemeColors.lightColor }}
                    subtitleStyle={{ color: lightThemeColors.lightColorFaded7 }}
                    gridDecoration={<GridAssetIcon />}
                    primaryButtonStyle={{ color: lightThemeColors.lightColor }}
                    primaryButtonVariant={lightThemeColors.footerBg}
                    outlineButtonStyle={{ color: lightThemeColors.darkColor, background: lightThemeColors.lightColor }}
                    outlineButtonVariant={lightThemeColors.lightColor}
                    title={"Ready to Drive Smarter Decisions?"}
                    subtitle={"Grovs empowers your Data & Analytics team to deliver precise insights, streamline attribution, and clearly demonstrate ROI."}
                />
                <TrackingComponent></TrackingComponent>
            </Container>
        </>
    )
}

export default DataAnalyticsPage

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
